export const FETCH_VISITS_REPORT = "[ADMIN] FETCH_VISITS_REPORT";
export const FETCH_VISITS_REPORT_START = "[ADMIN] FETCH_VISITS_REPORT_START";
export const FETCH_VISITS_REPORT_SUCCESS = "[ADMIN] FETCH_VISITS_REPORT_SUCCESS";
export const FETCH_VISITS_REPORT_ERROR = "[ADMIN] FETCH_VISITS_REPORT_ERROR";
export const FETCH_PAYMENTS_REPORT = "[ADMIN] FETCH_PAYMENTS_REPORT";
export const FETCH_PAYMENTS_REPORT_START = "[ADMIN] FETCH_PAYMENTS_REPORT_START";
export const FETCH_PAYMENTS_REPORT_SUCCESS = "[ADMIN] FETCH_PAYMENTS_REPORT_SUCCESS";
export const FETCH_PAYMENTS_REPORT_ERROR = "[ADMIN] FETCH_PAYMENTS_REPORT_ERROR";
export const SET_VISITS_REPORT_PAGINATION = "[ADMIN] SET_VISITS_REPORT_PAGINATION";
export const SET_PAYMENTS_REPORT_PAGINATION = "[ADMIN] SET_PAYMENTS_REPORT_PAGINATION"
export const RESET_VISITS_REPORT = "[ADMIN] RESET_VISITS_REPORT";
export const RESET_PAYMENTS_REPORT = "[ADMIN] RESET_PAYMENTS_REPORT";

export const fetchVisitsReport = (payload) => {
    return {
        type: FETCH_VISITS_REPORT,
        payload
    }
}

export const fetchPaymentsReport = (payload) => {
    return {
        type: FETCH_PAYMENTS_REPORT,
        payload
    }
}

export const resetVisitsReport = () => {
    return {
        type: RESET_VISITS_REPORT
    }
}

export const resetPaymentsReport = () => {
    return {
        type: RESET_PAYMENTS_REPORT
    }
}